angular
	.module 'App.Module.Account.Payment', []
	.config ($stateProvider) ->
		$stateProvider
			.state 'settings.payments',
				url: '/payments',
				views:
					'main@':
						controller: 'PaymentController'
						templateUrl: '@app/payment/payment.view.html'
				data:
					pageTitle: 'Settings - Payments'
					hideSubMenu: false
					restrict: 'Backoffice.TopMenu.Setting.Payments'
